import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=de23907a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=de23907a&prod&lang=scss&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=de23907a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de23907a",
  null
  
)

export default component.exports